export default "__VITE_ASSET__HYq4vYpS__"